import {Loader2, RefreshCw} from "lucide-react";

import type {ComponentProps} from "react";



import {Button} from "@/components/ui/button";

import {cn} from "@/lib/utils";



import {DESKTOP_APP_HEADER_HEIGHT_CLASS} from "../lib/desktop-app-header";

import {
  PageHeaderDetailBreadcrumb,
  PageHeaderDetailBreadcrumbSkeleton,
} from "./page-header-detail-breadcrumb";



function PageContent({children, className}: {children: React.ReactNode; className?: string}) {

  return <div className={cn("w-full space-y-4 p-4 md:p-6", className)}>{children}</div>;

}



function PageHeader({children, className}: {children: React.ReactNode; className?: string}) {

  return (

    <div

      className={cn(

        "bg-background flex w-full flex-row items-center justify-between gap-3 border-b border-border px-4 shadow-xs md:px-6",

        DESKTOP_APP_HEADER_HEIGHT_CLASS,

        className,

      )}

    >

      {children}

    </div>

  );

}



function TitleWrapper({

  dir = "row",

  children,

  className,

}: {

  dir?: "row" | "column";

  children: React.ReactNode;

  className?: string;

}) {

  const flexDirection = dir === "row" ? "flex-row items-center gap-2" : "flex-col items-start";

  return <div className={cn("flex min-w-0", flexDirection, className)}>{children}</div>;

}



function Title({title, className}: {title: React.ReactNode; className?: string}) {

  return (

    <h2 className={cn("text-base font-bold text-foreground md:text-xl", className)}>{title}</h2>

  );

}



function RefreshButton({

  onRefresh,

  isFetching = false,

  size,

  className,

}: {

  onRefresh: () => void;

  isFetching?: boolean;

  size?: ComponentProps<typeof Button>["size"];

  className?: string;

}) {

  return (

    <Button

      variant="ghost"

      size={size}

      className={cn(

        size === "icon"

          ? "text-muted-foreground hover:text-foreground shrink-0"

          : "text-primary",

        className,

      )}

      onClick={onRefresh}

      disabled={isFetching}

      aria-label="Refresh"

    >

      {isFetching ? (

        <Loader2

          aria-hidden

          data-icon={size === "icon" ? undefined : "inline-start"}

          className="size-4 animate-spin"

        />

      ) : (

        <RefreshCw

          aria-hidden

          data-icon={size === "icon" ? undefined : "inline-start"}

          className="size-4"

        />

      )}

    </Button>

  );

}



function Actions({children}: {children: React.ReactNode}) {

  return (

    <div className="flex items-center justify-center gap-2 text-xs md:ml-auto">{children}</div>

  );

}



PageHeader.TitleWrapper = TitleWrapper;

PageHeader.Title = Title;

PageHeader.RefreshButton = RefreshButton;

PageHeader.Actions = Actions;

PageHeader.DetailBreadcrumb = PageHeaderDetailBreadcrumb;

PageHeader.DetailBreadcrumbSkeleton = PageHeaderDetailBreadcrumbSkeleton;



export {PageHeader, PageContent};


